// The one call to action on the public site: a qualified pilot request.
export const PILOT_PATH = '/enroll?intent=pilot';

// Decided by Peter 2026-10-22 (sales brief). Pilot only; do not widen it here.
export const PILOT_GUARANTEE = 'Three-month paid pilot with a success test agreed in writing before day one. If we miss it, month three is not billed.';

export const STEPS = [
  {
    n: 1,
    title: 'Describe',
    blurb: 'Tell Spectra what you need in plain language: target properties, elements to include or avoid, application context. Every generated spec stays editable.',
    long: 'Type your target in plain language. Spectra decomposes it into a formal generation spec, and a deterministic router selects the right model variant for the job. No prompt engineering, no file wrangling. Prefer a fine-grained approach? Review the generated spec, adjust objectives and constraints, and pick model variants manually at any point.',
  },
  {
    n: 2,
    title: 'Generate and rank',
    blurb: 'Generative models propose novel candidates, scored and ranked by structural quality.',
    long: 'Generative models (MatterGen for inorganic crystals, FM4M and GT4SD for molecules) propose candidate structures. Every candidate is scored for structural quality and ranked, with an interactive 3D viewer for each structure.',
  },
  {
    n: 3,
    title: 'Analyze and report',
    blurb: 'Deep structural analysis, DFT validation, and patent-grade reports on your top candidates.',
    long: 'Run symmetry, bonding, and stability analyses. Validate top candidates with DFT (GPAW and Quantum ESPRESSO). Compare against known materials in external databases. Export formal patent-grade reports.',
  },
];
